<template lang="pug">
.meta-management
  h1 资料管理
  .sections
    .section
      .title 房间备注标签
      el-input(v-model='tags' type="textarea" :rows='30')
      br
      el-button(@click='saveTags' type="primary") 保存
</template>

<script>
export default {
  name: 'rooms-managerment',
  data() {
    return {
      tags: '',
    }
  },
  computed: {
    room_notes_tags() {
      return this.$store.state.summary.meta.room_notes_tags
    },
  },
  watch: {
    room_notes_tags: {
      immediate: true,
      handler() {
        this.tags = this.$store.state.summary.meta.room_notes_tags.join('\n')
      },
    },
  },
  methods: {
    saveTags() {
      const tags = this.tags.split('\n').filter(i => i)

      this.$http.post('meta/room_notes_tags', tags)
        .then(() => this.$store.dispatch('load_meta'))
    },
  },
}
</script>

<style lang="less">
.meta-management {
  .sections {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// MetaManagement.vue?39adff29